import { extendTheme } from "@chakra-ui/react";
import { fontsTheme } from "./fonts";
import { textStylesTheme } from "./textStyles";
import { tooltipTheme } from "./Tooltip";

export const customColors = {
  "--20": "#313435",
  "--25": "#3E4042",
  "--moba": "#69e4ff",
  "--white": "#ffffff",
  "--project-default-grey": "#abadad",
  "--delete-title": "#ff7a7a",
  "--w-8_hover": "rgba(255, 255, 255, 0.08)",
  "--w-16": "rgba(255, 255, 255, 0.16)",
  "--w-24": "rgba(255, 255, 255, 0.24)",
  "--hover-big": "rgba(255, 255, 255, 0.04)",
  "--80": "rgba(202, 205, 206, 1)",
  "--error-red": "#FF6464",
};

const customTheme = extendTheme({
  fonts: fontsTheme,
  textStyles: textStylesTheme,
  components: {
    Tooltip: tooltipTheme,
  },
  colors: customColors,
});

export default customTheme;
